export default [
  {
    path: '/ticketResource/ticketOrderList',
    component: () => import('../pages/ticketOrderList/index.vue'),
    name: 'TicketOrderList',
    meta: {
      title: '我的订单',
      activeBar: 'order'
    },
  },
  {
    path: '/ticketResource/ticketOrder',
    component: () => import('../pages/ticketOrder/index.vue'),
    name: 'TicketOrder',
    meta: {
      title: '门票订单',
      activeBar: 'order'
    },
  },
  {
    path: '/ticketResource/ticketPay',
    component: () => import('../pages/ticketPay/index.vue'),
    name: 'TicketPay',
    meta: {
      title: '收银台',
      activeBar: 'order'
    },
  },
  {
    path: '/ticketResource/ticketApplyRefund',
    component: () => import('../pages/ticketApplyRefund/index.vue'),
    name: 'TicketApplyRefund',
    meta: {
      title: '申请退款',
      activeBar: 'order'
    },
  },
  {
    path: '/ticketResource/ticketRefundProgress',
    component: () => import('../pages/ticketRefundProgress/index.vue'),
    name: 'TicketRefundProgress',
    meta: {
      title: '退款进度',
      activeBar: 'order'
    },
  },
]